import React, { useMemo } from "react";

const PoaResumenFactores = ({ data }) => {

    // 1) Aplanar todos los arrays detalle
    const allDetalles = useMemo(
        () => data.flatMap((proj) => proj.detalle || []),
        [data]
    );

    // 2) Agrupar por fase y sumar metas
    const resumenPorFase = useMemo(() => {
        if (allDetalles.length === 0) return [];

        const grupos = allDetalles.reduce((acc, rec) => {
            const { fase, indicador } = rec;
            const meta = parseFloat(indicador?.meta) || 0;
            const ejecutada = parseFloat(indicador?.meta_ejecutada) || 0;

            if (!acc[fase.oid]) {
                acc[fase.oid] = {
                    fase,
                    totalMeta: 0,
                    totalEjecutada: 0,
                };
            }
            acc[fase.oid].totalMeta += meta;
            acc[fase.oid].totalEjecutada += ejecutada;
            return acc;
        }, {});

        return Object.values(grupos).map(({ fase, totalMeta, totalEjecutada }) => {
            const porcentaje =
                totalMeta > 0 ? (totalEjecutada / totalMeta) * 100 : 0;
            return {
                oid: fase.oid,
                nombre: fase.nombre_corto,
                descripcion: fase.nombre_largo,
                totalMeta,
                totalEjecutada,
                avance: porcentaje.toFixed(1), // un decimal
                color: fase.color,
            };
        });
    }, [allDetalles]);

    if (resumenPorFase.length === 0) {
        return <p>No hay indicadores registrados en ningún proyecto.</p>;
    }
    const conversionData = [
        { rango: "0% - 50%", color: "#f20013", descripcion: "Bajo" },
        { rango: "51% - 75%", color: "#ffa500", descripcion: "Medio" },
        { rango: "76% - 100%", color: "#198754", descripcion: "Alto" }
    ];


    function getColorByAvance(avance) {
        const pct = parseFloat(avance);
        const item = conversionData.find(({ rango }) => {
            const [low, high] = rango.split("-").map(s =>
                parseInt(s.replace("%", "").trim(), 10)
            );
            return pct >= low && pct <= high;
        });
        return item ? item.color : "#000"; // negro por defecto si no encaja
    }



    return (
        <div className="poa-resumen">
            <h2>Consolidado por Factores</h2>
            <table>
                <thead>
                    <tr>
                        <th>Factor</th>
                        <th>Descripción</th>
                        <th>Meta</th>
                        <th>Meta Ejecutada</th>
                        <th>Avance (%)</th>
                    </tr>
                </thead>
                <tbody>
                    {resumenPorFase.map((f) => (
                        <tr key={f.oid}>
                            <td>{f.nombre}</td>
                            <td>{f.descripcion}</td>
                            <td style={{ textAlign: "center" }}>{f.totalMeta}</td>
                            <td style={{ textAlign: "center" }}>
                                {f.totalEjecutada != null
                                    ? parseFloat(f.totalEjecutada).toLocaleString("es-CO", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                    })
                                    : "-"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        color: getColorByAvance(f.avance)
                                    }}
                                >
                                    {f.avance}%
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <style jsx>{`
        .poa-resumen {
          padding: 20px;
          background-color: #f9f9f9;
          border-radius: 8px;
        }
        h2 {
          margin-bottom: 20px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th,
        td {
          padding: 10px;
          text-align: left;
          border-bottom: 1px solid #ddd;
        }
        th {
          background-color: #f2f2f2;
          text-align: center;
        }
      `}</style>
        </div>
    );
};

export default PoaResumenFactores;
